"use client";

import { useEffect, useRef } from "react";
import { KOFI_HANDLE } from "@/lib/kofi";

declare global {
  interface Window {
    kofiwidget2?: {
      init: (text: string, color: string, id: string) => void;
      getHTML: () => string;
      draw: () => void;
    };
  }
}

export function KofiButton() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const render = () => {
      if (!ref.current || !window.kofiwidget2) return;
      window.kofiwidget2.init("Support me on Ko-fi", "#21c45d", KOFI_HANDLE);
      ref.current.innerHTML = window.kofiwidget2.getHTML();
    };

    if (window.kofiwidget2) {
      render();
      return;
    }

    const existing = document.querySelector<HTMLScriptElement>(
      'script[src="https://storage.ko-fi.com/cdn/widget/Widget_2.js"]',
    );
    if (existing) {
      existing.addEventListener("load", render, { once: true });
      return;
    }

    // The widget lives in the footer (below the fold), so load its external
    // script during idle time rather than competing with first paint.
    const load = () => {
      const script = document.createElement("script");
      script.src = "https://storage.ko-fi.com/cdn/widget/Widget_2.js";
      script.async = true;
      script.addEventListener("load", render, { once: true });
      document.body.appendChild(script);
    };

    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(load, { timeout: 3000 });
      return () => window.cancelIdleCallback(id);
    }
    const id = window.setTimeout(load, 1);
    return () => window.clearTimeout(id);
  }, []);

  return <div ref={ref} />;
}
